import { DeleteButton, Edit, FileField, FileInput, FormDataConsumer, ImageField, ImageInput, NumberInput, required, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar, TranslatableInputs, useGetOne, useRecordContext } from 'react-admin';
import { useParams } from 'react-router-dom';
import { locales } from '../../../i18n/languges';
import { DestinationBlockType } from '../../../shared/enums/destination-page.enum';

const blockTypeChoices = [
  { id: DestinationBlockType.Title, name: 'resources.enums.destinationBlockType.title' },
  { id: DestinationBlockType.Body, name: 'resources.enums.destinationBlockType.body' },
  { id: DestinationBlockType.Image, name: 'resources.enums.destinationBlockType.image' },
  { id: DestinationBlockType.Video, name: 'resources.enums.destinationBlockType.video' },
];

const EditToolbar = (props: { pageId: number }) => (
  <Toolbar>
    <SaveButton />
    <DeleteButton redirect={`/destinationpages/${props.pageId}`} />
  </Toolbar>
);

export const DestinationPageBlockEdit = () => {
  const record = useRecordContext();
  const { blockId } = useParams();
  const id = record?.id ?? blockId;
  const block = useGetOne('destinationpages/blocks', { id });
  const pageId = block?.data?.pageId;

  const renderTypeSpecificFields = (blockType?: DestinationBlockType) => {
    switch (blockType) {
      case DestinationBlockType.Title:
        return (
          <TranslatableInputs locales={locales} sx={{ marginBottom: '2rem' }}>
            <TextInput
              source="content"
              label="resources.destinationpages.fields.content"
              fullWidth
              validate={[required()]}
            />
          </TranslatableInputs>
        );

      case DestinationBlockType.Body:
        return (
          <TranslatableInputs locales={locales} sx={{ marginBottom: '2rem' }}>
            <TextInput
              source="content"
              label="resources.destinationpages.fields.content"
              multiline
              minRows={6}
              fullWidth
              validate={[required()]}
            />
          </TranslatableInputs>
        );

      case DestinationBlockType.Image:
        return (
          <>
            <NumberInput source="mediaHeight" label="resources.destinationpages.fields.mediaHeight" min={120} max={700} />
            <TranslatableInputs locales={locales} sx={{ marginBottom: '2rem' }}>
              <TextInput source="caption" label="resources.destinationpages.fields.caption" fullWidth />
            </TranslatableInputs>
            <ImageInput source="media" multiple={false} accept={{ 'image/*': [] }}>
              <ImageField source="src" title="title" />
            </ImageInput>
          </>
        );

      case DestinationBlockType.Video:
        return (
          <>
            <NumberInput source="mediaHeight" label="resources.destinationpages.fields.mediaHeight" min={120} max={700} />
            <TranslatableInputs locales={locales} sx={{ marginBottom: '2rem' }}>
              <TextInput source="caption" label="resources.destinationpages.fields.caption" fullWidth />
            </TranslatableInputs>
            <FileInput source="media" multiple={false} accept={{ 'video/*': [] }}>
              <FileField source="src" title="title" />
            </FileInput>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Edit resource="destinationpages/blocks" id={id} redirect={`/destinationpages/${pageId}`}>
      <SimpleForm toolbar={<EditToolbar pageId={pageId} />}>
        <SelectInput
          source="blockType"
          choices={blockTypeChoices}
          validate={[required()]}
          label="resources.destinationpages.fields.blockType"
        />

        <NumberInput source="priority" label="resources.destinationpages.fields.priority" />

        <FormDataConsumer>
          {({ formData }) => renderTypeSpecificFields(formData?.blockType as DestinationBlockType)}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};
